import { h } from "omi";

export function TopicListSkeleton() {
  return (
    <div class="animate-fadeInFast">
      <div class="animate-pulse grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {[1, 2, 3].map(() => (
          <div class="rounded-2xl flex-1 h-52 m-0.5 bg-secondary whitespace-nowrap"> </div>
        ))}
      </div>
    </div>
  );
}
